define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/comm",
	"csi/comm/Aspera",
	"csi/comm/GetRequest",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,csi,Controller,comm,Aspera,GetRequest,PostRequest,locale,MessageDialog,xml) {

	const SITEADMIN_MODULE = "SiteAdmin";

	return declare(Controller, {
		hasToConfirmAction: function() {
			// summary: ask if merged PDF should be included if there is one and select set is of products
			var node = this.getNode();
           	return this._isTypeProduct() && xml.isValidURL(this.getNode().PDF);
		},

        onConfirm: function(/*String*/key) {
            // summary: if configured to confirm action, then start now that confirmed
			if (key == "C") {
				this.postProcess();
			} else {
				this.bIncludeMergedPDF = (key == "INCLUDE");
				this.preProcess();
			}
        },

        confirmAction: function(/*Object*/params) {
            // summary: customize confirmation dialog for including merged PDF, but be careful not to overwrite the buttons if they are passed,
            // as this is also called from the EmailZipController with different buttons.
            params.title = params.title || this.m_action.m_name;
            params.message = params.message || locale.typeAction("SelectSet", "DownloadSelectSetZip_Confirm");
       		params.buttons = params.buttons || ["INCLUDE", "NO_INCLUDE", MessageDialog.BUTTON_CANCEL];
			return this.inherited(arguments);
        },

		toWriter: function() {
			if (Aspera.isEnabled()) {
				let transferSpec = null;
				let request = new GetRequest(SITEADMIN_MODULE, "DownloadSelectSetZipAspera")
					.addParameter("URL", this.m_urlNode)
					.get({handleAs: "json"}).then(
						(response) => {
							transferSpec = response.data;
							return Aspera.downloadFileFromSpec(transferSpec);
						}
					).then(
						function() {
							if (transferSpec) {
								let deleteRequest = new PostRequest(SITEADMIN_MODULE, "DeleteDataPackageZip");
								deleteRequest.addParameter("FileName", transferSpec.transfer_specs[0].transfer_spec.paths[0].destination);
								return deleteRequest.post();
							} else {
								return null;
							}
						}
					).then(
						(msg) => {
							this.postProcess();
						}
					);
			} else {
				// summary: download the zip file in a separate browser window
				var request = new GetRequest(SITEADMIN_MODULE, "DownloadSelectSetZip")
					.addParameter("URL", this.m_urlNode)
					.addParameter("IncludeMergedPDF", this.bIncludeMergedPDF);

				csi.browserWindow(request.toRequest());
			}
		},

		_isTypeProduct: function() {
			// summary: return if SelectSet's type is for products
            var node = this.getNode();
            return (node.Subtype == "centric://REFLECTION/INSTANCE/SelectSetSubtype/Style") || (node.Subtype == "centric://REFLECTION/INSTANCE/SelectSetSubtype/Material");
		},

		_preAction: function() {
			// summary: send request to determine if there is a Zip file to send
			var cache = this.m_cache;
            var self = this;

            this.bIncludeMergedPDF = !this._isTypeProduct();
            this.m_writer.callMethod(SITEADMIN_MODULE, "VerifyDownloadSelectSetZip").addParameter(xml.PROP_URL, xml.ATTR_REF, this.m_urlNode);

			return this.m_writer.execute().then(
				function(response) {
					cache.cacheResponse(response);
				},
				function(response) {
					self._onPublishError(response);
				}
			);
		}
    });
});